<finra-card show-menu-control="false" show-expand-control="false">
  <div class="font-sans text-2xl font-semibold" style="padding: 0 15px 15px 10px">Available Actions</div>
  <div class="grid gap-4 text-base">
    <div class="grid gap-5 mx-4">
      <ng-container *ngFor="let shortcut of links">
        <a
          (click)="shortcut.onClick()"
          [attr.data-analytics-id]="pendoMappings[shortcut.pendoMapping]"
          [target]="shortcut.target"
          style="cursor: pointer"
        >
          {{ shortcut.label }}
        </a>
      </ng-container>
    </div>
  </div>
</finra-card>
